import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "../../../Translation";
import Badge from "../../Badge";
import { ArrowDownIcon, ArrowsPointingOutIcon, ChevronDownIcon, Cog8ToothIcon, DocumentIcon, ExclamationCircleIcon, MinusIcon, PlusIcon, TableCellsIcon, ClockIcon } from "@heroicons/react/24/outline";
import { split, webhook } from "../../../Resources/Images";
import { TextInput } from "../../Inputs/TextInput";
import { TextArea } from "../../Inputs/TextArea";
import { Button } from "../../Buttons";
import Tabs, { useTabs } from "../../Tabs";
import { useAPI } from "../../../API";
import Select from "../../Inputs/Select";
import { bgColor, checkedBg, checkedBorder, classNames, focusOutline, hoverBgColor, indeterminateBg, indeterminateBorder, textColor } from "../../../Resources/CSS/styling";
import Checkbox from "../../Inputs/Checkbox";

export const timezoneOptions = [
    {id: 1, name: "America/St_Johns", value: "America/St_Johns"},
    {id: 2, name: "America/Halifax", value: "America/Halifax"},
    {id: 3, name: "America/Glace_Bay", value: "America/Glace_Bay"},
    {id: 4, name: "America/Moncton", value: "America/Moncton"},
    {id: 5, name: "America/Goose_Bay", value: "America/Goose_Bay"},
    {id: 6, name: "America/Toronto", value: "America/Toronto"},
    {id: 7, name: "America/Iqaluit", value: "America/Iqaluit"},
    {id: 8, name: "America/Nipigon", value: "America/Nipigon"},
    {id: 9, name: "America/Thunder_Bay", value: "America/Thunder_Bay"},
    {id: 10, name: "America/Pangnirtung", value: "America/Pangnirtung"},
    {id: 11, name: "America/Atikokan", value: "America/Atikokan"},
    {id: 12, name: "America/Winnipeg", value: "America/Winnipeg"},
    {id: 13, name: "America/Rankin_Inlet", value: "America/Rankin_Inlet"},
    {id: 14, name: "America/Rainy_River", value: "America/Rainy_River"},
    {id: 15, name: "America/Regina", value: "America/Regina"},
    {id: 16, name: "America/Swift_Current", value: "America/Swift_Current"},
    {id: 17, name: "America/Edmonton", value: "America/Edmonton"},
    {id: 18, name: "America/Cambridge_Bay", value: "America/Cambridge_Bay"},
    {id: 19, name: "America/Inuvik", value: "America/Inuvik"},
    {id: 20, name: "America/Dawson_Creek", value: "America/Dawson_Creek"},
    {id: 21, name: "America/Yellowknife", value: "America/Yellowknife"},
    {id: 22, name: "America/Vancouver", value: "America/Vancouver"},
    {id: 23, name: "America/Whitehorse", value: "America/Whitehorse"},
    {id: 24, name: "America/Dawson", value: "America/Dawson"},
    {id: 25, name: "America/New_York", value: "America/New_York"},
    {id: 26, name: "America/Detroit", value: "America/Detroit"},
    {id: 27, name: "America/Kentucky/Louisville", value: "America/Kentucky/Louisville"},
    {id: 28, name: "America/Kentucky/Monticello", value: "America/Kentucky/Monticello"},
    {id: 29, name: "America/Indiana/Indianapolis", value: "America/Indiana/Indianapolis"},
    {id: 30, name: "America/Indiana/Vincennes", value: "America/Indiana/Vincennes"},
    {id: 31, name: "America/Indiana/Winamac", value: "America/Indiana/Winamac"},
    {id: 32, name: "America/Indiana/Marengo", value: "America/Indiana/Marengo"},
    {id: 33, name: "America/Indiana/Petersburg", value: "America/Indiana/Petersburg"},
    {id: 34, name: "America/Indiana/Vevay", value: "America/Indiana/Vevay"},
    {id: 35, name: "America/Chicago", value: "America/Chicago"},
    {id: 36, name: "America/Indiana/Tell_City", value: "America/Indiana/Tell_City"},
    {id: 37, name: "America/Indiana/Knox", value: "America/Indiana/Knox"},
    {id: 38, name: "America/Menominee", value: "America/Menominee"},
    {id: 39, name: "America/North_Dakota/Center", value: "America/North_Dakota/Center"},
    {id: 40, name: "America/North_Dakota/New_Salem", value: "America/North_Dakota/New_Salem"},
    {id: 41, name: "America/North_Dakota/Beulah", value: "America/North_Dakota/Beulah"},
    {id: 42, name: "America/Denver", value: "America/Denver"},
    {id: 43, name: "America/Boise", value: "America/Boise"},
    {id: 44, name: "America/Phoenix", value: "America/Phoenix"},
    {id: 45, name: "America/Los_Angeles", value: "America/Los_Angeles"},
    {id: 46, name: "America/Anchorage", value: "America/Anchorage"},
    {id: 47, name: "America/Juneau", value: "America/Juneau"},
    {id: 48, name: "America/Sitka", value: "America/Sitka"},
    {id: 49, name: "America/Metlakatla", value: "America/Metlakatla"},
    {id: 50, name: "America/Yakutat", value: "America/Yakutat"},
    {id: 51, name: "America/Nome", value: "America/Nome"},
    {id: 52, name: "America/Adak", value: "America/Adak"},
    {id: 53, name: "Pacific/Honolulu", value: "Pacific/Honolulu"},
    {id: 54, name: "America/Mexico_City", value: "America/Mexico_City"},
    {id: 55, name: "America/Cancun", value: "America/Cancun"},
    {id: 56, name: "America/Merida", value: "America/Merida"},
    {id: 57, name: "America/Monterrey", value: "America/Monterrey"},
    {id: 58, name: "America/Matamoros", value: "America/Matamoros"},
    {id: 59, name: "America/Ojinaga", value: "America/Ojinaga"},
    {id: 60, name: "America/Chihuahua", value: "America/Chihuahua"},
    {id: 61, name: "America/Mazatlan", value: "America/Mazatlan"},
    {id: 62, name: "America/Hermosillo", value: "America/Hermosillo"},
    {id: 63, name: "America/Bahia_Banderas", value: "America/Bahia_Banderas"},
    {id: 64, name: "America/Tijuana", value: "America/Tijuana"},
    {id: 65, name: "America/Santa_Isabel", value: "America/Santa_Isabel"},
    {id: 66, name: "America/Nassau", value: "America/Nassau"},
    {id: 67, name: "America/Havana", value: "America/Havana"},
    {id: 68, name: "America/Jamaica", value: "America/Jamaica"}
  ].sort((a, b) => a.name.localeCompare(b.name));

  const getDelayUnits = ({ translate }) => {
    const delayUnits = [
        { id: 1, name: translate('automatisation.seconds'), value: 'SECONDS', coefficient: 1 },
        { id: 2, name: translate('automatisation.minutes'), value: 'MINUTES', coefficient: 60 },
        { id: 3, name: translate('automatisation.hours'), value: 'HOURS', coefficient: 3600 },
        { id: 4, name: translate('automatisation.days'), value: 'DAYS', coefficient: 86400 },
    ];

    return delayUnits;
  }

const ConfigurationTab = ({ tmpStep, setTmpStep, save, error, isCreate }) => {

    const { translate } = useTranslation();
    const api = useAPI();

    const setValue = (value) => {
        setTmpStep({ ...tmpStep, data: { ...tmpStep.data, delay: value * selectedDelayUnit.coefficient } });
    }

    const delayUnits = [
        { id: 1, name: translate('automatisation.seconds'), value: 'SECONDS', coefficient: 1 },
        { id: 2, name: translate('automatisation.minutes'), value: 'MINUTES', coefficient: 60 },
        { id: 3, name: translate('automatisation.hours'), value: 'HOURS', coefficient: 3600 },
        { id: 4, name: translate('automatisation.days'), value: 'DAYS', coefficient: 86400 },
    ];

    const selectedDelayUnit = delayUnits.find((unit) => unit.value.toLowerCase() === tmpStep.data.delay_unit?.toLowerCase()) || delayUnits[0];

    const setDelayUnit = (unit) => {
        setTmpStep({ ...tmpStep, data: { ...tmpStep.data, delay_unit: unit.value, delay: tmpStep.data.delay / selectedDelayUnit.coefficient * unit.coefficient } });
    }

    const setSpecificDate = (value) => {
        if (!value) {
            setTmpStep({ ...tmpStep, data: { ...tmpStep.data, timezone: null, hoursBetween: null, days: null } });
        } else {
            setTmpStep({ ...tmpStep, data: { ...tmpStep.data, timezone: 'America/Montreal' } });
        }
    }

    const setTimezone = (timezoneOption) => {
        setTmpStep({ ...tmpStep, data: { ...tmpStep.data, timezone: timezoneOption.value } });
    }

    const isSpecificDate = tmpStep.data.timezone;

    const delayAdaptedToUnit = tmpStep.data.delay / selectedDelayUnit.coefficient;

    const selectedTimezone = timezoneOptions.find((timezone) => timezone.value.toLowerCase() === tmpStep.data.timezone?.toLowerCase()) || timezoneOptions.find(x => x.name === 'America/Toronto');
      
    const useVariable = tmpStep.data.use_variable;

    const days = [
        { id: 1, name: translate('automatisation.monday'), value: 'MONDAY' },
        { id: 2, name: translate('automatisation.tuesday'), value: 'TUESDAY' },
        { id: 3, name: translate('automatisation.wednesday'), value: 'WEDNESDAY' },
        { id: 4, name: translate('automatisation.thursday'), value: 'THURSDAY' },
        { id: 5, name: translate('automatisation.friday'), value: 'FRIDAY' },
        { id: 6, name: translate('automatisation.saturday'), value: 'SATURDAY' },
        { id: 7, name: translate('automatisation.sunday'), value: 'SUNDAY' },
    ]

    const setDays = (day) => {

        const newDays = [...(tmpStep.data.days || [])];

        if (newDays.includes(day)) {
            newDays.splice(newDays.indexOf(day), 1);
        } else {
            newDays.push(day);
        }

        setTmpStep({ ...tmpStep, data: { ...tmpStep.data, days: newDays } });
    }

    const setHoursBetweenFrom = (value) => {
        setTmpStep({ ...tmpStep, data: { ...tmpStep.data, hoursBetween: { ...tmpStep.data.hoursBetween, from: value } } });
    }

    const setHoursBetweenTo = (value) => {
        setTmpStep({ ...tmpStep, data: { ...tmpStep.data, hoursBetween: { ...tmpStep.data.hoursBetween, to: value } } });
    }

    const sourceOptions = [
        { id: 'event', name: translate('automatisation.from_event') },
        { id: 'contact', name: translate('automatisation.from_contact') },
        { id: 'global', name: translate('automatisation.from_global') }
    ];

    const selectedSource = sourceOptions.find(source => tmpStep.data.delay_variable?.startsWith && tmpStep.data.delay_variable?.startsWith(source.id)) || sourceOptions[0];

    const setSource = (source) => {
        const newDelayVariable = source.id + tmpStep.data.delay_variable?.split(selectedSource.id + ".")[1];
        setTmpStep({ ...tmpStep, data: { ...tmpStep.data, source: source.id, delay_variable: newDelayVariable } });
    }

    const setVariable = (variable) => {
        setTmpStep({ ...tmpStep, data: { ...tmpStep.data, delay_variable: selectedSource.id + "." + variable } });
    }

    const setUseVariable = (value) => {
        setTmpStep({ ...tmpStep, data: { ...tmpStep.data, use_variable: value } });
    }

    const delayVariable = tmpStep.data.delay_variable?.split(selectedSource.id + ".").slice(1).join(".") || '';
  
    return (
        <div className="flex flex-col mt-4 overflow-visible">

            {error && <p className="text-red-600 flex flex-row items-center bg-red-50 p-4"><ExclamationCircleIcon className="w-6 h-6 mr-2" />{error}</p>}

            <Checkbox label={translate('automatisation.use_variable')} id="use_variable" checked={useVariable} onChange={() => setUseVariable(!useVariable)} />
            {useVariable && <div className="flex flex-col mt-2">
                <p className="text-xl text-gray-600 font-bold">{translate('automatisation.variable')}</p>
                <p className="text-md text-gray-600 font-medium mt-2">{translate('automatisation.from')}</p>
                <Select selected={selectedSource} options={sourceOptions} setSelected={(e) => setSource(e)} />

                <p className="text-md text-gray-600 font-medium mt-2">{translate('automatisation.value')}</p>
                <TextInput value={delayVariable} onChange={(e) => setVariable(e.target.value)} />
            </div>}

            {!useVariable && <div>
                <p className="text-xl text-gray-600 font-bold">{translate('automatisation.delay_value')}</p>
                <TextInput type="number" value={delayAdaptedToUnit} onChange={(e) => setValue(e.target.value)}  />
            </div>}
            

            <p className="text-xl text-gray-600 font-bold mt-2">{translate('automatisation.delay_type')}</p>
            <Select selected={selectedDelayUnit} options={delayUnits} setSelected={(e) => setDelayUnit(e)} />

            
            <div className="flex flex-col mt-8">
                <Checkbox label={translate('automatisation.specific_date')} id="specific_date" checked={isSpecificDate} onChange={() => setSpecificDate(!isSpecificDate)} />
                {isSpecificDate && <div className="flex flex-col mt-2">
                    <p className="text-xl text-gray-600 font-bold mt-2">{translate('automatisation.timezone')}</p>
                    <Select selected={selectedTimezone} options={timezoneOptions} setSelected={(e) => setTimezone(e)} />

                    <p className="text-xl text-gray-600 font-bold mt-2">{translate('automatisation.delay_type')}</p>
                    {days.map((day) => <Checkbox label={day.name} id={day.value} checked={tmpStep.data.days?.includes(day.id)} onChange={() => setDays(day.id)} />)}

                    <p className="text-xl text-gray-600 font-bold mt-2">{translate('automatisation.hours_between')}</p>
                    
                    <p className="text-sm/6 text-gray-600 font-medium mt-2">{translate('automatisation.hours_between_from')}</p>
                    <TextInput type="number" value={tmpStep.data.hoursBetween?.from} onChange={(e) => setHoursBetweenFrom(e.target.value)} />

                    <p className="text-sm/6 text-gray-600 font-medium mt-2">{translate('automatisation.hours_between_to')}</p>
                    <TextInput type="number" value={tmpStep.data.hoursBetween?.to} onChange={(e) => setHoursBetweenTo(e.target.value)} />
                </div>}
            </div>

            {!isCreate && <div className="flex flex-row w-full flex-1 justify-end mt-4">
                <div className="flex flex-row">
                    <Button className="bg-black hover:bg-gray-800" onClick={() => save(tmpStep)}>
                        {translate('save')}
                    </Button>
                </div>
            </div>}
        </div>
    )
}

const DescriptionTab = ({ tmpStep, setTmpStep, save, isCreate }) => {
    const { translate } = useTranslation();
    return (
        <div className="flex flex-col mt-4">
            <p className="text-xl text-gray-600 font-bold">{translate('automatisation.description')}</p>
            <TextArea rows={5} value={tmpStep.description} onChange={(e) => setTmpStep({ ...tmpStep, description: e.target.value })} />

            {!isCreate && <div className="flex flex-row w-full flex-1 justify-end mt-4">
                <div className="flex flex-row">
                    <Button className="bg-black hover:bg-gray-800" onClick={() => save(tmpStep, JSON.stringify(tmpStep.data.body))}>
                        {translate('save')}
                    </Button>
                </div>
            </div>}
        </div>
    )
}

export default function DelayPanel({ setStepToClone, panelHook, step, refresh, deleteStep, isCreate, onCreateNewStep }) {
    const { translate } = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);
    const [tmpStep, setTmpStep] = useState({ ...step });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const api = useAPI();

    const tabs = useTabs([
        { icon: Cog8ToothIcon, name: translate('automatisation.configuration'), current: true },
        { icon: DocumentIcon, name: translate('automatisation.description'), current: false }
    ]);
    
    // Reset tmpStep when panel is closed
    useEffect(() => {
        if (!panelHook.open) {
            setTmpStep({ ...step });
        }
    }, [panelHook.open]);

    const save = async (tmpStep) => {


        try {
           
            if (isCreate) {

                if (!tmpStep.description || tmpStep.description.trim() === '') {
                    if (tmpStep.data.use_variable) {
                        tmpStep.description = "Delay from variable " + tmpStep.data.delay_variable;
                    } else {
                        const delayUnits = getDelayUnits({ translate });
                        const selectedDelayUnit = delayUnits.find((unit) => unit.value.toLowerCase() === tmpStep.data.delay_unit?.toLowerCase()) || delayUnits[0];
                        const delayAdaptedToUnit = tmpStep.data.delay / selectedDelayUnit.coefficient;
                        tmpStep.description = 'Time: ' + delayAdaptedToUnit + ' ' + (selectedDelayUnit.name || 'seconds');
                    }
                }

                const newStepResponse = await api.createAutomatisationStep(tmpStep.automatisation_id, tmpStep);
                if (newStepResponse.data.automatisation_step) {
                    onCreateNewStep(newStepResponse.data.automatisation_step);
                }
            } else {
                await api.updateAutomatisationStep(tmpStep.automatisation_id, tmpStep);
            }

            panelHook.setOpen(false);
            setTimeout(() => {
                refresh();
            }, 1000);
        } catch (e) {
            setError('Invalid JSON');
            return;
        }

    }

    const selectStepToClone = (step) => {
        setStepToClone(step);
        panelHook.setOpen(false);
    }


    return (
        <div className="flex flex-col flex-1 rounded-md p-4 overflow-hidden h-full w-96">
            <div className="flex flex-row items-center">
                <ClockIcon className={`w-12 h-12 min-w-12 min-h-12 aspect-square border p-2 bg-gray-50 rounded-md mr-2 ${textColor}`} />
                <div className="flex flex-col ml-2">
                    <h2 className="text-xl font-bold">{translate('automatisation.delay')}</h2>
                </div>
                
                <div className="flex flex-row flex-1 justify-end">

                {!isCreate && <Button className="bg-red-600 hover:bg-red-300 ml-4" onClick={deleteStep}>
                        {translate('delete')}
                    </Button>}
                {isCreate && <Button className={`${bgColor} ${hoverBgColor} ml-4 opacity-100`} onClick={() => save(tmpStep)}>{translate('create')}</Button>}
                {!isCreate && <Button className={`${bgColor} ${hoverBgColor} ml-4 opacity-100`} onClick={() => selectStepToClone(tmpStep)}>{translate('clone')}</Button>}
                </div>
            </div>

            <div className="flex flex-row overflow-x-scroll no-scrollbar">
                <Tabs tabs={tabs} />
            </div>

            {tabs.currentTabIndex === 0 && <ConfigurationTab tmpStep={tmpStep} setTmpStep={setTmpStep} panelHook={panelHook} error={error} save={save} isCreate={isCreate} />}
            {tabs.currentTabIndex === 1 && <DescriptionTab tmpStep={tmpStep} setTmpStep={setTmpStep} panelHook={panelHook} error={error} save={save} isCreate={isCreate} />}
        </div>
    )
}